export default {
  MEMBERS: ['', '普通会员', '白银会员', '黄金会员', '钻石会员'],
  RENEW_TYPE_TOGETHER: 2, //同时换新方式
  RENEW_TYPE_SINGLE: 1, // 单独回收
  RENEW_TOGETHER_LABEL: '上门送新机，同时回收旧机',
  RENEW_TOGETHER_TIP: '旧机款和换新补贴立即抵扣，仅需支付差价',
  RENEW_SINGLE_LABEL: '先送新机，旧机单独回收',
  RENEW_SINGLE_TIP: '先付新机款，回收款单独发放',
  OLD_TRADE_TYPE_TEST: 1,
  OLD_TRADE_TYPE_PICK: 2,
  OLD_TRADE_TYPE_POST: 3,
  OLD_TRADE_TYPE_OBJ: {
    1: {
      type: 1,
      label: '上门检测',
      tip: '质检员上门检测，现场拿回收款'
    },
    2: {
      type: 2,
      label: '上门取件',
      tip: '顺丰上门，免费取件'
    },
    3: {
      type: 3,
      label: '邮寄回收',
      tip: '自行快递邮寄'
    }
  }
}
